export const STORE_HOSTNAME = 'STORE_HOSTNAME';
export const STORE_PORT = 'STORE_PORT';
export const STORE_NONCE = 'STORE_NONCE';
export const ANCHOR_TAG = 'ANCHOR_TAG';
export const SCROLL_COMPONENT_TO_VIEWPORT = 'SCROLL_COMPONENT_TO_VIEWPORT';
export const RESET_SCROLL_COMPONENT_TO_VIEWPORT = 'RESET_SCROLL_COMPONENT_TO_VIEWPORT';

const abCookies = ['atlc2', 'atlssmo'];
const newBucket = new RegExp(/^atln_/);

export function storeHostnameAction(hostname) {
	return { type: STORE_HOSTNAME, payload: hostname };
}

export function storeHostPortAction(port) {
	return { type: STORE_PORT, payload: port };
}

export function storeNonceAction(nonce) {
	return { type: STORE_NONCE, payload: nonce };
}

export function enableScrollComponentToViewport(scrollComponentType, isScrollable) {
	return {
		type: SCROLL_COMPONENT_TO_VIEWPORT,
		scrollComponentType,
		isScrollable
	};
}

export function resetScrollComponentToViewport() {
	return {
		type: RESET_SCROLL_COMPONENT_TO_VIEWPORT
	};
}

export function setLinkTypeBasedOnAB(cookies) {
	const linkTypeMap = abCookies.reduce((linkTypeMap, key) => {
		const cookieValue = cookies[key];

		linkTypeMap[key] = !newBucket.test(cookieValue);
		return linkTypeMap;
	}, {});
	return {
		type: ANCHOR_TAG,
		value: linkTypeMap
	};
}
